/**
 * Created by masoud on 06/05/17.
 */
import React from "react";
import createClass from "create-react-class";
import PropTypes from "prop-types";
import { isMobile } from "react-device-detect";

const DownloadLinks = require("./DownloadLinks.react");
require("../../../../less/DownloadSection.less");
const DownloadSection = createClass({
  displayName: "DownloadSection",
  getDefaultProps() {
    return {
      sms_link: null
    };
  },
  render() {
    return (
      <div className="Download-Section">
        <div className={"Texts" + (isMobile ? " Texts-Small" : "")}>
          <h2>
            دانلود برنامه <span className="snapp">اسنپ</span> مسافران
          </h2>
          <DownloadLinks />
        </div>
      </div>
    );
  }
});

DownloadSection.propTypes = {
  sms_link: PropTypes.string
};

module.exports = DownloadSection;



// WEBPACK FOOTER //
// ./src/js/components/Pages/DownloadPage/DownloadSection.react.js